module.exports = __webpack_public_path__ + "img/executor.7088a79b.svg";